<template>
  <Row v-if="dataArr&&dataArr.length>0">
    <Col
      span="16"
      class="img"
    >
    <Carousel
      class="hotSeason"
      v-model="Carousel.indx"
      :height="Carousel.setting.height"
      :autoplay="Carousel.setting.autoplay"
      :autoplay-speed="Carousel.setting.autoplaySpeed"
      :dots="Carousel.setting.dots"
      :radius-dot="Carousel.setting.radiusDot"
      :trigger="Carousel.setting.trigger"
      :arrow="Carousel.setting.arrow"
    >
      <CarouselItem
        v-for="(item,index) in dataArr"
        :key="index"
      >
        <div class="demo-carousel">
          <img
            v-if="item.piclist&&item.piclist.length>0&&(String(item.piclist[0].upadder).startsWith('http')||String(item.piclist[0].upadder).startsWith('https'))"
            :src="item.piclist&&item.piclist.length>0?item.piclist[0].upadder:''"
            alt=""
          >
          <img  v-else  src="../imgs/noViewPic.jpg" />
        </div>
      </CarouselItem>
    </Carousel>
    </Col>
    <Col span="8">
    <div class="ivewInfo">
      <loading v-show="!currentData"></loading>
      <p class="tit" :title="currentData?currentData.szscenicname:''">{{currentData?currentData.szscenicname:''}}</p>
      <p class="grade" v-if="currentData.strgrade">{{currentData.strgrade}}</p>
      <p  class="introduce"  v-html="currentData.szsimpleintroduction" ></p>
      <p class="price">￥<span> {{currentData.price||'0.00'}}</span>元起/人</p>
      <button class="btn"  @click="buyNow(currentData.iscenicid)"  >立即购票</button>
    </div>
    </Col>
  </Row>
  <div
    v-else
    class="noData"
  >暂无数据</div>
</template>

<script>
export default {
  props: {
    dataArr: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      lgtp: sessionStorage.getItem('lgtp'),
      currentDataArr: [],
      currentData: {},
      Carousel: {
        indx: 0,
        setting: {
          height: 340,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: 'inside',
          radiusDot: true,
          trigger: 'click',
          arrow: 'never'
        },
      },
    }
  },
  watch: {
    dataArr: {
      handler: function (val) {
        console.log(1111, val)
        if (val) {
          this.currentData = val[0];
          this.currentDataArr = val
        }
      },
      deep: true
    },
    'Carousel.indx': {
      handler: function (index, oldIndex) {
        this.currentData = [...this.currentDataArr][index]
      },
      deep: true
    }
  },
  methods: {
    /**
     * 立即购票
     * **/
    buyNow (id) {
      let query = this.$route.query;
      if (Object.keys(query).length && query.fxsId) {
        this.$router.push({
          name: 'ticketDetailPage',
          params: { id: id }
        });
      } else {
        if (this.lgtp === '02') {
          this.$router.push({
            name: 'distributor-order'
          });
        } else {
          this.$router.push({
            name: 'ticketDetailPage',
            params: { id: id }
          });
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
@white: #fff;
@gray: #646566;
@gradColor: #ed5714;
@mainBule: #4b7ff0;
@hoverColor: #69b2f6;
@imgwidth: 605px;
@imgHeight: 340px;
@fontSize12: 12px;
@fontSize14: 14px;
@fontSize17: 17px;
@fontSize24: 24px;
.img {
  width: @imgwidth;
  height: @imgHeight;
  img {
    object-fit: cover;
    width: @imgwidth;
    height: @imgHeight;
  }
}
.ivu-col-span-8 {
  width: 28.8% !important;
}
.ivewInfo {
  margin-left: 25px;
  font-size: @fontSize14;
  .tit {
    font-weight: 700;
    font-size: @fontSize24;
    color: #323233;
    margin-top: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .grade {
    display: inline-block;
    border: 1px solid @gradColor;
    border-radius: 4px;
    padding: 2px 4px;
    margin-top: 5px;
    font-size: @fontSize12;
    color: @gradColor;
  }
  .introduce {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 5;
    -moz-box-orient: vertical;
    height: 120px;
    overflow: hidden;
    margin-top: @fontSize12;
    font-size: @fontSize14;
    line-height: 25px;
    color: @gray;
  }
  .price {
    color: @mainBule;
    margin-top: 22px;
    font-size: @fontSize17;
    span {
      font-weight: 700;
      font-size: @fontSize24;
    }
  }
  .btn {
    width: 120px;
    height: 36px;
    border: 0px;
    border-radius: 5px;
    margin-top: 15px;
    background: @mainBule;
    color: @white;
    &:hover {
      background: @hoverColor;
    }
  }
}
// 暂无数据样式
.noData {
  text-align: center;
  line-height: 310px;
}
</style>

<style scoped>
.hotSeason >>> .ivu-carousel-dots-inside {
  bottom: 20px;
}
.hotSeason >>> .ivu-carousel-dots li {
  margin: 0 5px;
}
.hotSeason >>> .ivu-carousel-dots li button {
  background: #fff;
  opacity: 1;
  border: 1px solid #ffffff;
  border-radius: 100px;
  width: 12px;
  height: 12px;
}
.hotSeason >>> .ivu-carousel-dots .ivu-carousel-active button {
  background: #4b7ff0;
  border: 1px solid #4b7ff0;
}
</style>
